module.exports = __webpack_public_path__ + "assets/logo-blue.4a322c6c.svg";